export class AlterarStatusAgendamento {
  id: number;
  status: number;
  nota: string;
  encerrarTarefas = false;
  email = '';
}
